import React from 'react';
import {connect} from "react-redux";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  withStyles} from '@material-ui/core';
import { Form } from 'react-final-form'
import { Field } from 'react-final-form-html5-validation';

import {getHostedCheckout, toggleNewIngenicoWindow} from "../../actions/PaymentActions";

import {jump, inputUppercase} from "../utils/FormUtils"

import styles from "./customMaterialUIStyle"

@connect(store => {
	return {
    messages:store.messages.messages,
    payment: store.payment
}})

export default class IngenicoPaymentDialog extends React.Component {


  componentDidUpdate(){
    const {payment = {}, dispatch} = this.props;
    const {SEPA = {}} = payment;
    const {status = "FAIL"} = SEPA;
    if (status === "SUCCESS") {
      dispatch(savePaymentMethod());
    }
  }

  closeIngenicoPaymentDialog = () => {
    const { dispatch } = this.props;
    dispatch(toggleNewIngenicoWindow(false))
  }

  handleClickOpenIngenico = () => {
		const {dispatch} = this.props;
		dispatch(getHostedCheckout());
  }

  render() {
    const {messages, payment: {SEPA = {}}} = this.props;
    const {status: SepaStatus = "", error: SepaError = "" } = SEPA;

    return (
      <Dialog
        open={true}
        aria-labelledby="simple-dialog-title"
        maxWidth="md"
      >
        <DialogTitle id="form-dialog-title">{messages["common.label.blockPaymentCB"]}</DialogTitle>
        <DialogContent>
        </DialogContent>
        <DialogActions>
            <Button className="btn btn-theme-standard" onClick={this.closeIngenicoPaymentDialog} variant="contained">
                    {messages["common.button.cancel"]}
            </Button>
            <Button className="btn btn-theme-default" onClick={e=>this.handleClickOpenIngenico() } variant="contained">
                    {messages["common.button.continue"]}
            </Button>

          </DialogActions>
      </Dialog>
      );
  }
}



// WEBPACK FOOTER //
// ./src/opencell/pages/client/IngenicoPaymentDialog.jsx